import { render, staticRenderFns } from "./tabYS.vue?vue&type=template&id=76737e8b&scoped=true&"
import script from "./tabYS.vue?vue&type=script&lang=js&"
export * from "./tabYS.vue?vue&type=script&lang=js&"
import style0 from "./tabYS.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tabYS.vue?vue&type=style&index=1&id=76737e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76737e8b",
  null
  
)

export default component.exports